/** Case-insensitive permission helpers (API may send Read/Write/None). */

export function permissionOf(value) {
  return String(value || "None").toLowerCase();
}

export function hasStock(value) {
  return permissionOf(value) === "stock";
}

/** Stock-only grant: Devices page only (no sales pages, no Event/Product Management). */
export function isStockOnlyAccess(eventAcl) {
  if (!eventAcl) return false;
  const values = [eventAcl.Permission];
  (eventAcl.Stallholders || []).forEach((sh) => {
    values.push(sh.Permission);
    (sh.Stalls || []).forEach((stall) => values.push(stall.Permission));
  });
  const granted = values
    .map(permissionOf)
    .filter((p) => p && p !== "none" && p !== "undefined");
  return granted.length > 0 && granted.every((p) => p === "stock");
}

export function hasWrite(value) {
  return permissionOf(value) === "write";
}

export function hasReadOrWrite(value) {
  const permission = permissionOf(value);
  return permission === "read" || permission === "write";
}

/** True if Event or Stallholder has Read/Write (stall-level alone does not count). */
export function hasEventOrStallholderReadOrWrite(
  eventPermission,
  stallholderPermission
) {
  return (
    hasReadOrWrite(eventPermission) || hasReadOrWrite(stallholderPermission)
  );
}

/** Stallholder objects usable in return-object autocompletes (need a display name). */
export function isValidStallholderSelection(stallholder) {
  return Boolean(
    stallholder &&
      stallholder.StallholderId &&
      stallholder.StallholderName
  );
}
